export default __webpack_public_path__ + "static/media/btn-start-on.6e8f81d3.png";